import React from "react";
import styled from "styled-components";

export const Skill = styled.div`
  display: inline-block;
  padding: 5px 10px;
  margin: 5px;
  background: #eaeaea;
  border-radius: 20px;
  color: #555;
  font-weight: 500;
`;

const Skills = ({ skills }) => {
  const skill = skills.split(",");
  return (
    <div>
      {skill.map((item, key) => {
        return <Skill>{item}</Skill>;
      })}
    </div>
  );
};

export default Skills;
